import { Link } from "react-router-dom";

export default function Logo({ size = "default" }) {
  const text = size === "large" ? "text-3xl" : "text-xl";
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
      <div className="relative h-9 w-9 grid place-items-center rounded-xl bg-gradient-to-br from-blue-500 via-indigo-500 to-indigo-700 glow-blue-soft">
        <span className="font-display font-extrabold text-white text-lg leading-none">K</span>
        <span className="absolute inset-0 rounded-xl ring-1 ring-white/20" />
      </div>
      <span className={`font-display font-extrabold tracking-tight ${text} text-white`}>
        Kavion<span className="text-blue-400">.</span>
      </span>
    </Link>
  );
}
